export const TranslationIdMap = '';

export const TranslationKeyMap = {
    '_763_CLOSE': 'Close',
    '_11221_IMPORT_TRANSCRIPT': 'Import Transcript',
    '_11223_CONFIRMATION_MESSAGE': 'Confirm which active focus you would like to associate this transcript to or choose to not assign a focus.',
    '_121_CANCEL': 'Cancel',
    '_11224_DO_NOT_ASSOCIATE': 'Do Not Associate',
    '_11225_ASSOCIATE_FOCUS': 'Associate Focus'
};
